import {createRouter, createWebHistory} from 'vue-router';
import TB20220531 from '../views/TBview/20220531';
import TB20221024 from '../views/TBview/20221024';
import TB20221027 from '../views/TBview/20221027';
import BDDWATCH from '../views/BDDWATCH';
const routes = [
  {
    path: '/',
    redirect: 'customer-service',
  },
  {
    path: '/customer-service',
    name: 'CustomerService',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/customer-service.vue'),
  },
  {
    path: '/customer-service2',
    name: 'CustomerService2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/customer-service2.vue'),
  },
  {
    path: '/TB20220531',
    name: 'TB20220531',
    // component: () => import(/* webpackChunkName: "about" */ '../views/h5view.vue')
    component: TB20220531,
  },
  {
    path: '/TB20221024',
    name: 'TB20221024',
    // component: () => import(/* webpackChunkName: "about" */ '../views/h5view.vue')
    component: TB20221024,
  },
  {
    path: '/TB20221027',
    name: 'TB20221027',
    // component: () => import(/* webpackChunkName: "about" */ '../views/h5view.vue')
    component: TB20221027,
  },
  {
    path: '/BDDWATCH',
    name: 'BDDWATCH',
    // component: () => import(/* webpackChunkName: "about" */ '../views/h5view.vue')
    component: BDDWATCH,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
